import NextImage from "next/image";

import { classNameGenerator, clsx } from "@/utils";

import styles from "./RealWorldTransformation.module.scss";
import { useAppSelector } from "@/hooks";
import Typography from "@/foundation/Typography/V2";

interface RealWorldTransformationProps {}

const RealWorldTransformation: React.FC<RealWorldTransformationProps> = () => {
  const { data: bootCampPageData } = useAppSelector((state) => state?.bootCamp);

  if(!bootCampPageData?.realWorldTransformation)
    return <></>
    
  const {
    heading,
    description,
    transformationData,
    transformationGoals,
    isListLayout,
  } = bootCampPageData?.realWorldTransformation || {};
  const { title, goalList, alignment } = transformationGoals || {};

  const cls = classNameGenerator(styles);

  return (
    <section id="RealWorldTransformation">
      <div className={cls("RealWorldTransformation")}>
        <div className={cls("topSectionWrapper")}>
          <div className={cls("topSection")}>
            <div className={cls("headerSection")}>
              <Typography variant="heading3" className={cls("title")}>
                {heading}
              </Typography>
              <Typography variant="heading3" className={cls("description")}>
                {description}
              </Typography>
            </div>
            {!isListLayout && (
              <div className={cls("gridSection")}>
                {transformationData?.map((item: any, index: number) => {
                  return (
                    <div
                      key={index}
                      className={cls("transformationItemContainer")}
                    >
                      <NextImage
                        src={item?.imageLink}
                        className={cls("transformationImage")}
                        alt={item?.label}
                        fill
                      />
                      <NextImage
                        src={item?.imageUrlWeb}
                        className={cls("transformationImageWeb")}
                        alt={item?.label}
                        fill
                      />
                      <div className={cls("textContainer")}>
                        <Typography
                          variant="paragraph4"
                          className={cls("percentageText")}
                        >
                          {item?.percentage}
                        </Typography>
                        <Typography
                          variant="paragraph4"
                          className={cls("label")}
                          dangerouslySetInnerHTML={{ __html: item?.label }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {isListLayout && (
              <div className={cls("listSection")}>
                {transformationData?.map((item: any, index: number) => {
                  return (
                    <div
                      key={index}
                      className={cls("transformationListItemContainer")}
                    >
                      {Icon2}
                      <Typography
                        variant="paragraph4"
                        className={cls("description")}
                      >
                        {item?.label}
                      </Typography>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <div className={cls("bottomSectionWrapper")}>
          <div className={cls("bottomSection")}>
            <Typography variant="heading6" className={cls("title")}>
              {title}
            </Typography>
            <div className={clsx(cls("goalContainer"), cls(alignment))}>
              {goalList?.map((item: any, index: number) => {
                return (
                  <div key={index} className={cls("goalListItem")}>
                    {checkIcon}
                    <div className={cls("textContainer")}>
                      <Typography
                        variant="paragraph3"
                        className={cls("heading")}
                      >
                        {item?.title}
                      </Typography>
                      <Typography
                        variant="paragraph4"
                        className={cls("description")}
                      >
                        {item?.description}
                      </Typography>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RealWorldTransformation;

const checkIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 11.2868V11.9308C18.9991 13.4403 18.5103 14.909 17.6065 16.118C16.7027 17.327 15.4323 18.2115 13.9847 18.6395C12.5372 19.0675 10.9901 19.0161 9.57413 18.493C8.15818 17.9698 6.94926 17.003 6.12767 15.7367C5.30609 14.4704 4.91585 12.9724 5.01517 11.4662C5.11449 9.95996 5.69804 8.52619 6.6788 7.37871C7.65955 6.23124 8.98495 5.43153 10.4573 5.09887C11.9297 4.7662 13.4702 4.9184 14.849 5.53276"
      stroke="#101828"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0013 6.09351L11.8218 13.0935L9.66797 10.9956"
      stroke="#101828"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Icon2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
  >
    <path
      d="M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26Z"
      stroke="#FEC84B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0938 13C13.3289 12.3316 13.7929 11.7681 14.4037 11.4091C15.0145 11.0501 15.7326 10.9189 16.4309 11.0387C17.1292 11.1584 17.7626 11.5215 18.2188 12.0635C18.6751 12.6055 18.9248 13.2915 18.9237 14C18.9237 16 15.9237 17 15.9237 17"
      stroke="#FEC84B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 21H16.01"
      stroke="#FEC84B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
